import { IBomPart } from 'bom/types';
import { TextLine } from 'core/elements';

interface IProps {
  bomPart: IBomPart;
}

export const PartDescriptionTypeComponent = ({ bomPart }: IProps) => {
  return (
    <TextLine
      text={bomPart?.componentEmpty ? '' : bomPart?.componentName}
      maxRows={4}
      textEllipsis
      italic
    />
  );
};
